<template>
  <span :uk-icon="definition"></span>
</template>

<script>
import DynamicProps from '@/mixins/DynamicProps';

export default {
  name: 'icon',
  mixins: [DynamicProps],
  props: {
    name: String,
    ratio: {
      type: String,
      default: '1',
    },
  },
  computed: {
    definition() {
      const rules = [`icon: ${this.name}`];
      if (this.ratio !== '1') {
        rules.push(`ratio: ${this.ratio}`);
      }
      return rules.join('; ');
    },
  },
};
</script>



// WEBPACK FOOTER //
// Icon.vue?67e9ea56